export const getEnvVariable = (key) => {
  if (typeof window !== "undefined" && window.env) {
    return window.env[key];
  }
  return process.env[key];
}
